export const BASE_URL = "https://api.pyrexiaaiims.in";